import classNames from "classnames";

export interface WellProps {
  backgroundNone?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const Well = ({
  children,
  backgroundNone = false,
  className = "",
}: WellProps) => (
  <div
    className={classNames(
      "rounded-md bg-none px-4 py-5 sm:p-6",
      {
        "bg-none": backgroundNone,
        "bg-tertiary": !backgroundNone,
      },
      className,
    )}
  >
    {children}
  </div>
);
